import { signalsToPointXY } from './signalsToPointXY';
const defaultSimulationOptions = {
    maxClusterSize: 1,
};
export function getSumOfShapes(internalSignals, options) {
    const simulationOptions = { ...defaultSimulationOptions, ...options };
    return function sumOfShapes(parameters) {
        const peaks = [];
        for (const internalSignal of internalSignals) {
            const delta = parameters[internalSignal.fromIndex];
            const intensity = parameters[internalSignal.fromIndex + 1];
            for (let i = 2; i < internalSignal.parameters.length; i++) {
                //@ts-expect-error Not simply to solve the issue
                internalSignal.shapeFct[internalSignal.parameters[i]] =
                    parameters[internalSignal.fromIndex + i];
            }
            const couplings = internalSignal.signal.js;
            for (let i = 0; i < couplings.length; i++) {
                couplings[i].coupling =
                    parameters[internalSignal.fromIndexCoupling + i];
            }
            const currentPeaks = signalsToPointXY([
                {
                    delta,
                    js: couplings,
                },
            ], simulationOptions);
            peaks.push(...currentPeaks.map((peak) => {
                return { intensity, shape: internalSignal.shapeFct, ...peak };
            }));
        }
        return (currentX) => {
            let totalY = 0;
            for (let peak of peaks) {
                const { x, y, intensity, shape } = peak;
                totalY += y * intensity * shape.fct(currentX - x);
            }
            return totalY;
        };
    };
}
//# sourceMappingURL=getSumOfShapes.js.map